import Loading from "./Loading";

export default function FullLoading() {
  return (
    <div className="full-loading-container">
      <Loading variant="normal" />
    </div>
  );
}
